import { Api } from "../config/request";

const getUserPointsAndRewards = async (data) =>{
    let response= await Api.PostRequest("/getUserPointsAndRewards", data);
    return response.data;
}

const getUserRewards= async (data) =>{
    let response = await Api.PostRequest("/getUserRewards", data);
    return response.data;
}

const claimReward = async (data) =>{
    let response= await Api.PostRequest("/redeemRewards", data);
    return response.data;
}

const signUpForUpdates = async (data) =>{
    let response= await Api.PostRequest("/changeNotificationEmailAddress", data);
    return response.data;
}

const resendUpdateVerificationCode  = async (data) =>{
    let response= await Api.PostRequest("/resendUpdateVerificationCode", data);
    return response.data;
}

const optInForUpdates   = async (data) =>{
    let response= await Api.PostRequest("/optInForUpdates", data);
    return response.data;
}

const buyPoints = async(data)=>{
    let response= await Api.PostRequest("/purchasePoints", data);
    return response.data;
}

const updatePurchasedPointsStatus = async(data)=>{
    let response= await Api.PostRequest("/updatePurchasedPointsStatus", data);
    return response.data;
}

const rewardApi ={
    getUserPointsAndRewards,
    getUserRewards,
    claimReward,
    signUpForUpdates,
    buyPoints,
    updatePurchasedPointsStatus,
    resendUpdateVerificationCode,
    optInForUpdates
}

export default rewardApi;